import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiX } from 'react-icons/fi';

const FABSidebar = () => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = () => setOpen(!open);

  const handleNavigate = (path, loaderPath) => {
    setIsLoading(true);
    setOpen(false);

    // Step 1: Navigate to loader screen
    navigate(loaderPath);

    // Step 2: After 1 second, navigate to actual path
    setTimeout(() => {
      navigate(path);
      setIsLoading(false);
    }, 1000);
  };

  const menuItems = [
    { label: 'New conversations', emoji: '✨', path: '/chat', loaderPath: '/chat' },
    { label: 'Discover Careers', emoji: '🎯', path: '/discover-careers', loaderPath: '/discover-careers-loader' },
    { label: 'Career Progress',   emoji: '📍', path: '/career-progress', loaderPath: '/career-progress-loader' },
    { label: 'Recommended Skills', emoji: '🔥', path: '/recommended-skills', loaderPath: '/recommended-skills-loader' },
    { label: 'Career Transition', emoji: '💼', path: '/career-transition', loaderPath: '/career-transition-loader' },
    { label: 'Career Videos (YT)', emoji: '🎬', path: '/career-videos', loaderPath: '/career-videos-loader' },
    { label: 'Learn & Grow', emoji: '📚', path: '/learn-and-grow', loaderPath: '/learn-and-grow-loader' },
    { label: 'Soft Skills', emoji: '🗣️', path: '/soft-skills', loaderPath: '/soft-skills-loader' },
    { label: 'Startup Ideas', emoji: '🚀', path: '/startup', loaderPath: '/startup-loader' },
    { label: 'Daily Quote / Journal', emoji: '📝', path: '/daily-quote', loaderPath: '/daily-quote-loader' },
    { label: 'Your Future Self', emoji: '🎨', path: '/future-self', loaderPath: '/future-self-loader' },
  ];

  return (
    <>
      {/* 🔄 Loader */}
      {isLoading && (
        <div className="fixed z-50 top-0 left-0 w-full h-full bg-black bg-opacity-40 flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      {/* 📱 Sidebar Drawer */}
      {open && (
        <div className="fixed z-50 bottom-[90px] right-6 bg-white rounded-xl shadow-xl py-2 px-4 w-[230px] text-sm font-sora font-semibold text-stone-800 animate-fadeIn flex flex-col gap-2">
          {menuItems.map((item, idx) => {
            const isActive = location.pathname.startsWith(item.path);

            return (
              <p
                key={idx}
                onClick={() => handleNavigate(item.path, item.loaderPath)}
                className={`px-3 py-2 rounded-lg cursor-pointer transition-all ${
                  isActive ? 'bg-orange-200 font-bold' : 'hover:bg-orange-100'
                }`}
              >
                {item.emoji} {item.label}
              </p>
            );
          })}
        </div>
      )}

      {/* ➕ Floating Action Button */}
      <div className="fixed bottom-40 right-6 z-50">
        <button
          onClick={handleToggle}
          className="w-14 h-14 bg-orange-500 text-white text-2xl rounded-full shadow-md flex items-center justify-center hover:scale-105 active:scale-95 transition-all"
        >
          {open ? <FiX size={30} /> : '+'}
        </button>
      </div>
    </>
  );
};

export default FABSidebar;
